import { useEffect, useState } from "react";
import useInView from "../../../Hooks/useInView";

const CountUp = ({ target, suffix = "" }) => {
  const [val, setVal] = useState(0);
  const [ref, vis] = useInView(0.4);
  useEffect(() => {
    if (!vis) return;
    let start = 0;
    const step = Math.ceil(target / 60);
    const id = setInterval(() => {
      start += step;
      if (start >= target) {
        setVal(target);
        clearInterval(id);
      } else setVal(start);
    }, 20);
    return () => clearInterval(id);
  }, [vis, target]);
  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
};

export default CountUp;
